export const TIPO_MENSAGEM = {
    
    DUVIDA: "DUVIDA",
    INTERESSE: "INTERESSE",
    FORMULARIO_PERSONALIZADO: "FORMULARIO_PERSONALIZADO"
    
}